<template>
  <div class="deviceDetail">
    <div class="top">
      <span class="name">{{$t("device.deviceName")}}：{{deviceInfo.devalias || deviceInfo.sn}}</span>
      <span class="label">
        <i class="status-icon" :class="deviceStatus.class"></i>
        {{deviceStatus.label}}
      </span>
    </div>
    <ul class="tab">
      <li class="tab-item" v-for="(value,key) in tabs" :key="key" :class="{active:activeTab==key}" @click="activeTab=key">{{value}}</li>
    </ul>
    <component :is="activeTab" class="content"></component>
  </div>
</template>
<script>
import statistic from './statistic'
import chart from './chart'
import analysis from './analysis'
import clause from './clause'
// import Protocol from './Protocol'
import { mapGetters } from 'vuex'
export default {
  components: {
    statistic,
    chart,
    analysis,
    clause,
    // Protocol
  },
  data() {
    return {
      tabs: {
        statistic: this.$t('device.overview'),
        chart: this.$t('device.chart'),
        analysis: this.$t('device.analysis'),
        // Protocol: this.$t('device.Current_data'),
        clause: this.$t('device.clause'),
      },
      activeTab: 'statistic', // 当前选中标签页序列号
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
    deviceStatus () {
      return this.$filter.deviceStatus[this.deviceInfo.status]
    }
  },
}
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/mixin.less');
.deviceDetail {
  background: #fff;
  display: flex;
  flex-direction: column;
  margin:10px;
  // margin: 24px 24px 50px 24px;
  border-radius: 4px;
  padding:15px;
  .top {
    padding: 5px 15px 5px 10px;
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    .name {
      .sc(16px, #333);
      font-weight: bold;
    }
    .label {
      padding: 5px 20px;
      border-radius: 25px;
      box-shadow: 0px -1px 2.5px #7F7F7F;;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0 10px;
      padding: 0px 20px;
      height: 32px;
      background-color: #fff;
      // border: 1px solid #000;
      border-radius: 18px;
      box-shadow: inset 0px 0px 5px 1px #ccc;
      .sc(14px, #333);
      .status-icon {
        width: 12px;
        height: 12px;
        margin-right: 5px;
      }
    }
  }
  .tab {
    // padding: 5px;
    display: flex;
    border-bottom: 1px solid #d9d9d9;
    // background: #EAF0F2;
    &-item {
      margin: 0 2px;
      padding: 10px 25px;
      .sc(14px, #808080);
      font-weight: 600;
      border: 1px solid #d9d9d9;
      border-bottom: none;
      cursor: pointer;
      &:hover {
        // border-color: @themeColor;
        // color: @themeColor;
        color: @hoverColor;;
        // font-weight: 900;
      }
      &.active {
        border-radius: 4px;
        background: @themeColor;
        color: #fff;
      }
    }
  }
  .content {
    flex: 1;
    display: flex;
    // flex-direction: row;
  }
}
</style>